/**
 * @file Select Account Identities container.
 */

import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import { MeWithIdentities } from '../../graphql/queries/account';
import SelectAccountIdentities from '../../components/discover/SelectAccountIdentities';
import { openModal } from '../../actions/modal-actions';
import { AlbumFolderWithIdentityAccess } from '../../graphql/queries/album-folder';

const withUserData = graphql(MeWithIdentities, {
  props: ({ data: { me, loading } }) => ({
    accountId: get(me, 'id'),
    identities: get(me, 'linked_identities.records'),
    loadingIdentities: loading,
  }),
});

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  albumFolderId: discoverAlbumFolder.albumFolderId,
});

const mapDispatchToProps = {
  openModal,
};

const withAlbumFolderData = graphql(AlbumFolderWithIdentityAccess, {
  options: ({ albumFolderId }) => ({
    variables: {
      id: albumFolderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loadingAlbumFolder: loading,
  }),
  skip: ({ albumFolderId }) => !albumFolderId,
});

export default compose(
  withRouter,
  withUserData,
  connect(mapStateToProps, mapDispatchToProps),
  withAlbumFolderData,
)(SelectAccountIdentities);
